export default __webpack_public_path__ + "static/media/resumePic2.3d7919db.png";